"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isInteger2 = _interopRequireDefault(require("lodash/isInteger"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _date = require("../../utils/date");
var _excluded = ["duration"];
var FORMAT = 'mm:ss';
var Duration = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var duration = _ref.duration,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!(0, _isInteger2["default"])(duration) || duration < 0) {
    return null;
  }
  var durationTime = (0, _date.getDurationTime)({
    seconds: duration
  });
  return /*#__PURE__*/_react["default"].createElement(StyledDuration, props, (0, _format["default"])(durationTime, FORMAT));
});
Duration.displayName = 'Duration';
Duration.propTypes = {
  className: _propTypes["default"].string,
  duration: _propTypes["default"].number.isRequired
};
Duration.defaultProps = {
  className: ''
};
var StyledDuration = _styledComponents["default"].div.withConfig({
  displayName: "Duration__StyledDuration",
  componentId: "sc-19ipqvn-0"
})(["color:#4d4d4d;font-size:12px;"]);
var _default = exports["default"] = Duration;